export default __webpack_public_path__ + "static/Jet-Hero-Fixed-096b0057c6b263103aaca13e4bfbc338.png";